<template>
  <section class="products">
    <!-- <ul class="products--list"> -->
    <transition-group
      tag="ul"
      class="products--list"
      name="products"
      appear
    >
      <ProductCard
        v-for="(product, index) in products"
        :key="filterType+filterValue+product.id"
        :product="product"
        :teaser="teaser"
        :index="index"
        class="products-list-item"
      />
    </transition-group>
    <!-- </ul> -->
  </section>
</template>
<script>
import ProductCard from '@/components/layouts/products/ProductCard.vue';
import FilterMixin from '@/components/common/filter/FilterMixin.vue';

export default {
  name: 'ProductList',
  components: {
    ProductCard,
  },
  mixins: [FilterMixin],
  props: {
    teaser: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
    };
  },

  computed: {
    products() {
      let list = this.$products;
      if (this.filterType === 'value' && this.filterValue) {
        list = this.$getProductsByValue(this.filterValue);
      } else if (this.filterType === 'collection' && this.filterValue) {
        list = this.$getProductsByCollectionId(this.filterValue);
      }
      return this.teaser ? this.teasedProducts : this.$filterByWave(list, this.$currentWave);
    },

    teasedProducts() {
      const products = this.$excludeByWave(this.$products, this.$currentWave);
      return products.filter(product => product.teased === true || product.teased === undefined);
    },
  },
};
</script>
<style lang="stylus" scoped>
.products {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 55px;

  &--list {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      grid-gap: 20px;
      padding: 0 5px;
      margin: 0;
      list-style: none;
      perspective: 1000px;

      +desktop() {
        grid-template-columns: repeat(2, 1fr);
        padding: 0
      }
      +above(xl) {
        grid-template-columns: repeat(3, 1fr);
      }
      // +above(1680px) {
      //   grid-template-columns: repeat(4, 1fr);
      // }

      +vue-transition-group("products", (350ms 0ms), ease-out, (50ms 0ms), false) {
        transform: translateZ(30px) translateY(-20px)
        opacity: 0;
      }

      // display: flex;
      // flex-wrap: wrap;
      // justify-content: center;
      // align-items: flex-start;
      // align-content: flex-start;
      // gap: 20px;
      // padding: 0;
      // margin: 0 auto;
      // list-style: none;
      // width: fit-content;

    }
}
</style>
